import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ChartComponent } from '@syncfusion/ej2-angular-charts';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ajaxservice } from '../../../../services/ajaxservice';// Common API service for both get and post
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { IPointRenderEventArgs } from '@syncfusion/ej2-angular-charts';
import { Router } from '@angular/router';
import { identity, result } from 'lodash';
import { ThrowStmt } from '@angular/compiler';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { concatAll } from 'rxjs/operators';

@Component({
  selector: 'kt-customer-dashboard',
  templateUrl: './customer-dashboard.component.html',
  styleUrls: ['./customer-dashboard.component.scss']
})
export class CustomerDashboardComponent implements OnInit {

  //url navigations
  asideMenus: any;
  current_url: any;
  exist: any;
  public piedataticket: Object[];
  public piedata: Object[];
  public datalabel: Object;
  public datalabelticket: Object;
  public csatdatalabel: Object;
  public legendSettings: Object;
  public currentTicketLengendSettings: Object;
  public legendsettings: Object;
  public enableBorderOnMouseMove: boolean;
  public tooltip: Object;
  public freshpalette: any;
  public carrypalette: any;
  public csatpalette: any;
  public insightpalette: string[];
  @ViewChild(('chart'), { static: false })
  public chart: ChartComponent;
  @ViewChild(('chart1'), { static: false })
  public chart1: ChartComponent;
  @ViewChild(('chart2'), { static: false })
  public chart2: ChartComponent;
  @ViewChild(('chart3'), { static: false })
  public chart3: ChartComponent;
  @ViewChild(('chart4'), { static: false })
  public chart4: ChartComponent;
  @ViewChild(('chart5'), { static: false })
  public chart5: ChartComponent;
  @ViewChild(('chart6'), { static: false })
  public chart6: ChartComponent;
  @ViewChild(('chart7'), { static: false })
  public chart7: ChartComponent;
  public animation: Object;
  all_ticket_data: any;
  ticket_distribution: any;
  fresh: any;
  carryforward: any;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  title: string;
  public chartData: Object[];
  public primaryXAxis: Object;
  public primaryYAxis: Object;
  public primaryXAxis1: Object;
  public primaryYAxis1: Object;
  public primaryYAxis5: Object;
  public primaryXAxis5: Object;
  public primaryXAxis6: Object;
  public primaryYAxis6: Object;
  public primaryXAxis7: Object;
  public primaryYAxis7: Object;
  ticketdis_title: string;
  palette: string[];
  public marker: Object;
  public marker1: Object;
  csat_data: { x: string; y: any; }[];
  DatewiseData: Object[];
  DatewiseData1: Object[];
  LinechartComprehensiveData: Object[];
  LinechartLabourData: Object[];
  LinechartDemandData: Object[];
  LinechartPartData: Object[];
  LinechartWarrantyData: Object[];
  LinechartTotalData: Object[];
  c_sat_title: string;
  ticket_insights_title: string;
  spare_insights_title: string;
  SpareInsightsAmcData: Object[];
  SpareInsightsWarrantyData: Object[];
  RevenueInsightsNewAmcData: Object[];
  RevenueInsightsPercallData: Object[];
  RevenueInsightsContractRenData: Object[];
  RevenueInsightsSparesaleData: Object[];
  revenue_insights_title: string;
  public loaded;
  datevalue: any;
  product_id: any;
  product: any;
  CSatGroup: FormGroup;
  csat_data1: { x: { x: string; y: any; }; y: number; }[];
  tickets: any = [];
  ticketinsight: any;
  empty: Object;
  ticket_count_details: any = [];
  currentticket: FormGroup;
  ticketdistribution: FormGroup;
  tooltiptext: any;
  public radius: Object = { bottomLeft: 5, bottomRight: 5, topLeft: 5, topRight: 5 };
  enableSmartLabels: boolean;
  ProductLocation: FormGroup;
  dropdownProductSettings:any;
  dropdownregionSettings:any;
  region_id: any =[];
  productId: any=[];
  users: any;
  products: any;
  region: any;
  employee_code: string;
  productIdvalue:any =[];
  stateId: any=[];
  loadingSubmit: boolean;
  datapickerflag: boolean = true;
  from: any;
  to: any;
  defaultTo: any;
  defaultFrom: any;
  assetListData: any;
  complaintData: any;
  pmsData: any;
  contractData: any;
  mappingData: any;
  mappingDataChat: { x: string; y: any; }[];
  pmsDataChat: { x: string; y: any; }[];
  assetListDataChat: { x: string; y: number; }[];
  contractDataChat: { x: string; y: number; }[];
  complaintDataChat: { x: string; y: any; }[];
  datePeriod:any ="MTD"
  datapickerflag1: boolean = true;
  datePeriod1: any="MTD";
  product_id_value: any=[];
  regionId: any =[];
  states: any =[];
  dropdownStatesettings:any={};
  state_id: any =[];
  cusCode: string;
  public onDateRangeSelection(range: { from: Date, to: Date },item,date) {
		this.from = range.from;
		this.to = range.to;
    this.getDashboradStatus(date,item);
	}
  constructor(public ajax: ajaxservice, private chRef: ChangeDetectorRef, private router: Router,private calendar: NgbCalendar) {
     const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonthNumber = today.getMonth() + 1;
    // Get the day, month, and year
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = today.getFullYear();
    // Format the date as YYYY.MM.DD
    const formattedDate = `${year}-${month}-${day}`;
    this.defaultTo= formattedDate
    this.defaultFrom = (currentMonthNumber>=4)?( (new Date().getFullYear()+ '-' +'04' + '-' + '01')):((currentYear-1)+ '-' +'04' + '-' + '01');
    this.to = this.calendar.getToday();
    this.CSatGroup = new FormGroup({
      "product_id": new FormControl('', Validators.required),
      "datetime_value": new FormControl('Today', Validators.required)
    })
    this.currentticket = new FormGroup({
      "product_id": new FormControl("All", Validators.required),
      // "datetime_value": new FormControl('Today', Validators.required)
    })
    this.ticketdistribution = new FormGroup({
      "product_id": new FormControl("All", Validators.required),
      // "datetime_value": new FormControl('Today', Validators.required)
    })
  }
  // public pointRender(args: IPointRenderEventArgs): void {
  //   let seriesColor: string[] = ['#00bdae', '#404041', '#357cd2', '#e56590', '#f8b883',
  //     '#70ad47', '#dd8abd', '#7f84e8', '#7bb4eb', '#ea7a57'];
  //   args.fill = seriesColor[args.point.index];
  // };
  public emptyPointSettings: Object = {
    fill: '#e6e6e6',
  };
  public csatdata: Object[] = [
    { x: 'Customer Feedback', y: 20, DataLabelMappingName: 'Customer Feedback' },
    { x: 'First Call Closer', y: 60, DataLabelMappingName: 'First Call Closer' },
    { x: 'SLA Compliance', y: 10, DataLabelMappingName: 'SLA Compliance' }
];
  ngOnInit(): void {
    this.getProductDetails()
    localStorage.setItem('countPage',"")
    localStorage.setItem('durartion','');
    localStorage.setItem('toDate','');
    localStorage.setItem('fromDate','');
    localStorage.setItem('reportProduct','');
    localStorage.setItem('reportState','');
    this.ProductLocation = new FormGroup({
      "product_id": new FormControl('', Validators.required),
      "region_id": new FormControl('', Validators.required),
      // "date":new FormControl('MTD',Validators.required)
    });
    // let localState =localStorage.getItem('pro_state'); 
    // this.states =JSON.parse(localState);
    // if(this.stateId.length==0)this.states.filter(states => {this.stateId.push(states.id);});
    // this.productId = "All";
    // this.stateId = "All";
    // this.getpass();
    this.dropdownProductSettings = {
      singleSelection: false,
      idField: 'product_id',
      textField: 'product_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.dropdownregionSettings = {
      singleSelection: false,
      idField: 'region_id',
      textField: 'region',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // region multiselector settings
    this.dropdownStatesettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'state_name',
      selectAllText: 'Select State',
      unSelectAllText: 'UnSelect State',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    // this.asideMenus = localStorage.getItem('pro_asideMenus');
    // this.current_url = this.router.url;
    // const result = JSON.parse(this.asideMenus).filter(f => f.page === this.current_url)
    // if (result.length <= 0) {
    //   localStorage.clear();
    //   this.router.navigate(["/login"]);
    // } else {
      this.datevalue = "This Week";
      this.product_id = null;
      // this.getTicketTracker();
      // this.getproduct();
      // this.get_current_ticketes();
      // this.get_ticket_distribution();
      // this.get_c_sat();
      // this.get_ticket_insight();
  
      this.animation = { enable: true };
      this.enableBorderOnMouseMove = false;
      this.datalabel = { visible: true, name: 'text', position: 'Inside'
    };
    this.enableSmartLabels = true;
      this.csatdatalabel = { visible: true, position: 'Inside' };
      this.datalabelticket = { visible: true, name: 'text', position: 'Inside' };
      this.currentTicketLengendSettings = {
        visible: true, position: "Bottom", width: '160', height: '150'
      }
      this.legendSettings = {
        visible: true, position: "Bottom", width: '160', height: '100'
      };
      this.legendsettings = {
        visible: true, position: "Bottom", width: '110', height: '80'
      };
      this.tooltip = {
        enable: true,
        template: "<div id='templateWrap' style='background-color:${color};color:white;border-radius: 3px;font-size:14px; float: right;padding: 2px;line-height: 20px;text-align: center;height: 26px;width:52px;'>" +
        "<span>${y}</span></div>"
      }
      this.freshpalette = ['#253F68',"#68A1FF"];
      this.carrypalette = ['#91ADD9', '#3D5478', '#60A3F1'];
      this.csatpalette = ['#4C6381', '#EA8D8F', '#E38A56', '#7AACB3'];
      this.insightpalette = ['#4C6381', '#EA8D8F', '#E38A56', '#7AACB3'];
      this.empty = {
        mode: 'Zero', fill: 'pink', border: { width: 2, color: 'black' }
      }
      this.marker = {
        dataLabel: {
          visible: true
        }, visible: true, width: 10, height: 10
      };
      this.palette = ['#153043'];
    // }
    this.marker1 = {
      dataLabel: {
        visible: true,
        position: 'Top',
        font: {
          fontWeight: '600',
          color: '#ffffff',
        },
      },
    };
    this.from = this.defaultFrom;
		this.to = this.defaultTo;
    this.from = moment(this.from).format('YYYY-MM-DD');
		this.to = moment(this.to).format('YYYY-MM-DD');
    setTimeout(() => {
      this.getDashboradStatus(this.datePeriod,1);
    },1000);

  }
  getproduct() {
    var emp_code = localStorage.getItem('pro_employee_code')                     //declare emp_code for localstorage
    var url = 'get_product_details/?'; // api url for getting the details
    this.ajax.getdataparam(url,"employee_code",emp_code).subscribe((result) => {
      if (result.response.response_code == "200") { //if sucess
        this.product = result.response.data; //storing the api response in the array
        this.product.forEach(value => {
          this.productIdvalue.push(value.product_id); 
        })
      }
    }, (err) => { //if error
      console.log(err); //prints if it encounters an error
    });
  }
  //print the chart
  printTicket() { //print tickets
    this.chart.print();
  }
  printTricketSpare() { //print ticket distribution
    this.chart1.print();
  }
  printCsat() { //print csat
    this.chart2.print();
    this.chart7.print();
  }
  printInsight() { //print Insight
    this.chart3.print();
  }
  printInsightAmc() { //print insight Amc 
    this.chart4.print();
  }
  printRevenueInsight() { //print Revenue insight
    this.chart5.print();
  }
  exportTicketPNG() { //Export ticket PNG format
    this.chart.exportModule.export('PNG', 'Current Ticket');
    this.chart6.exportModule.export('PNG', 'Current Carry Forward Ticket');
  }
  exportTicketPDF() {//Export ticket PDF format
    this.chart.exportModule.export('PDF', 'Current Ticket');
    this.chart6.exportModule.export('PDF', 'Current Carry Forward Ticket');
  }
  exportTicketSparePNG() { //Export Ticket Spare PNG format
    this.chart1.exportModule.export('PNG', 'Ticket Distribution');
  }
  exportTicketSparePDF() { //Export tiket spare PDF format
    this.chart1.exportModule.export('PDF', 'Ticket Distribution');
  }
  exportCsatPNG() {//Export CSAT PNG format
    this.chart2.exportModule.export('PNG', 'C-Sat');
    this.chart7.exportModule.export('PNG', 'C-Sat Actual and Target Value');
  }
  exportCsatPDF() { //Export CSAT PDF  format
    this.chart2.exportModule.export('PDF', 'C-Sat');
    this.chart7.exportModule.export('PDF', 'C-Sat Actual and Target Value');
  }
  exportInsightPNG() {//Export Insignt PNG format
    this.chart3.exportModule.export('PNG', 'Ticket Insights');
  }
  exportInsightPDF() { //Export Insignt PDF format
    this.chart3.exportModule.export('PDF', 'Ticket Insights');
  }
  exportInsightAmcPNG() { //Export Insight Amc PNG format
    this.chart4.exportModule.export('PNG', 'Spare Insights');
  }
  exportInsightAmcPDF() { // Export Insight AMC PDF Format
    this.chart4.exportModule.export('PDF', 'Spare Insights');
  }
  exportRevenueInsightPNG() { //Export Revenue Insight PNG format
    this.chart5.exportModule.export('PNG', 'Revenue Insights');
  }
  exportRevenueInsightPDF() {//Export Revenue Insight PDF format
    this.chart5.exportModule.export('PDF', 'Revenue Insights');
  }
  get_current_ticketes() {
    var url = 'current_ticket?';             // api url for getting the details with using post params
    var emp_code = localStorage.getItem('pro_employee_code'); // get employee code 

    var employee_code = "employee_code";// Define post format variable
    var id = "product_id";
    var product_id = this.currentticket.value.product_id;
    this.ajax.getdatalocation(url, employee_code, emp_code,product_id,id).subscribe((result) => {//Initiate an API call to get the current tickets details 
      if (result.response.response_code == "200") {
        this.all_ticket_data = result.response.data;//Json resonse from API
        this.fresh = "Fresh:" + this.all_ticket_data['fresh'];//get the count for fresh tickets
        this.carryforward = "Carry Forward:" + this.all_ticket_data['carry_forward'];//count of carry forwarded tickets
        this.piedataticket = [
          // { 'x': 'Assigined', y: this.all_ticket_data['assigned'] }, { 'x': 'Unassigned', y: this.all_ticket_data['unassigned'] },
          // { 'x': 'Accepted', y: this.all_ticket_data['accepted'] }, { 'x': 'Deffered Support', y: this.all_ticket_data['deffered'] },
        ];//bind ticket data to pie chart 
        this.piedata = [
          // { 'x': 'Esclated', y: this.all_ticket_data['eslated'] }, { 'x': 'Spare requested', y: this.all_ticket_data['spare_requested'] },
          // { 'x': 'Inprogress', y: this.all_ticket_data['in_progress'] },
        ];//bind data to pie chart with esclates ,spare requested and Inprgress datas
        this.title = "CURRENT TICKETS";//define title to the pie chart
        this.chRef.detectChanges();//to detect the changes
        this.dtTrigger.next();
      }
    }, (err) => {
      console.log(err);                                        //prints if it encounters an error
    });
  }
  onchangeDay(value, identify) {//on change day or year month
    this.palette = ["#E94649", "#F6B53F", "#6FAAB0", "#C4C24A"];
    this.datevalue = value
    if (identify == 1) {//if 1 call ticket distribution
      this.get_ticket_distribution();
    }
    else if (identify == 2) {// else 
      // alert("c sat")
      this.datevalue = this.CSatGroup.value.datetime_value;//get date time 
      this.product_id = this.CSatGroup.value.product_id; //get product id
      if (this.datevalue == "") { //if the date time is null 
        this.datevalue = null;
      }
      else {
        this.datevalue = this.CSatGroup.value.datetime_value;
      }
      if (this.product_id == "") {//if product id is null
        this.product_id = null;
      }
      else {
        this.product_id = this.CSatGroup.value.product_id;
      }
      this.get_c_sat();// API call Function to CSAT
    }
    else if (identify == 3) {
      this.get_ticket_insight();// Function call to initiate ticket insight
    }
    else if (identify == 4) {
      this.get_ticket_insight();// Function call to initiate ticket insight
    }
  }
  onChangeProduct(value, identify) {
    this.product_id = value
    this.get_c_sat();
  }
  get_ticket_distribution() {//function to get ticket distribution details
    this.ticketdis_title = "TICKET DISTRIBUTION";
    var url = 'ticket_distribution/';             // api url for getting the details with using post params
    var emp_code = localStorage.getItem('pro_employee_code'); // get employee code 
    var data = { "employee_code": emp_code, "value": this.datevalue ,"product_id": this.ticketdistribution.value.product_id}//Json post data format
    this.ajax.postdata(url, data).subscribe((result) => {//API call to initiate to get the ticket distribution details
      if (result.response.response_code == "200") {
        this.ticket_distribution = result.response.data;//Json respose from API
        if (this.datevalue == "Today") {
          this.primaryXAxis = {
            valueType: 'Category',
            title: 'Time'
          };
        }
        else if (this.datevalue == "This Week") {
          this.primaryXAxis = {
            valueType: 'Category',
            title: 'Days'
          };
        }
        else if (this.datevalue == "This Month") {
          this.primaryXAxis = {
            valueType: 'Category',
            title: 'Days'
          };
        } else {
          this.primaryXAxis = {
            valueType: 'Category',
            title: 'Months'
          };

        }
        this.primaryYAxis = {
          title: ''
        };
        this.chRef.detectChanges();//Detect changes
        this.dtTrigger.next();
      }
    }, (err) => {
      console.log(err);                                        //prints if it encounters an error
    });
  }
  get_c_sat() {//Function to get CSAT
    this.c_sat_title = "C-SAT INSIGHTS(IN PERCENTAGE)";//Define title for Chart
    var url = 'c_sat/';             // api url for getting the details with using post params
    var emp_code = localStorage.getItem('pro_employee_code'); // get employee code 
    var data = { "employee_code": emp_code, "value": this.datevalue, "product_id": this.product_id }
    this.ajax.postdata(url, data).subscribe((result) => {
      if (result.response.response_code == "200") {
        this.csat_data = result.response.data1;//Get resposne data from API
        this.csat_data1 = result.response.data;
        this.primaryXAxis1 = {
          valueType: 'Category',
          // labelIntersectAction: 'Rotate45',
          labelRotation: 45,
        };
        this.primaryYAxis1 = {
          title: 'Percentage',
        };
        this.chRef.detectChanges();//Detect chnages
        this.dtTrigger.next();
      }
    }, (err) => {
      console.log(err);                                        //prints if it encounters an error
    });
  }
  get_ticket_insight() {
    this.ticket_insights_title = 'TICKET INSIGHTS';//Define Insight title
    var url = 'ticket_insight/';             // api url for getting the details with using post params
    var emp_code = localStorage.getItem('pro_employee_code'); // get employee code 
    var data = { "employee_code": emp_code, "value": this.datevalue }
    this.ajax.postdata(url, data).subscribe((result) => {//Initiate API Call
      if (result.response.response_code == "200") {//if response code 200 i.e Success
        this.LinechartComprehensiveData = result.response.data;//Get respose data
        this.primaryXAxis5 = {
          valueType: 'Category',
          title: 'Product',
          labelIntersectAction: 'Rotate45'
        };
        //Initializing Primary Y Axis
        this.primaryYAxis5 = {
          labelFormat: '{value}',
          title: 'No.of.tickets',

        };
        this.chRef.detectChanges();//Detect Changes
        this.dtTrigger.next();
      }
    }, (err) => {
      console.log(err);                                        //prints if it encounters an error
    });
  }
  // get the ticket tracking and counting code
  // getTicketTracker(){
  //   var url = 'ticket_tracker/?';    // api url for getting the count details with using get
  //   var data =   {
  //                 "employee_code":localStorage.getItem('pro_employee_code'),
  //                 "product":[],
  //                 "region":[],
  //                 'date':this.ProductLocation.value.date
  //               }
  //   this.ajax.postdata(url, data).subscribe((result) => { //Initiate API Call
  //     if(result.response.response_code == "200"){      //if response code 200 i.e Success
  //       this.ticket_count_details = result.response.data[0];
  //       this.chRef.detectChanges();//Detect changes
  //     }
      
  //   },(err)=>{
  //     console.log(err);        //prints if it encounters an error
  //   });
  
  // }

  onTextRender = (args: any) => {
    args.font.color = 'black';
  }

  pointRender = (args: any) => {
    if(args.point.yValue == 0) {
      args.cancel = true;
    }
  }
  ticketSummaryPage(value) {           //# to redirect to corresponting page  
    if(value==1||value==2||value==3){
      this.router.navigateByUrl('servicedesk/newticket');
      localStorage.setItem('routingValue', value);
    }else if(value==4||value==7){
      this.router.navigateByUrl('servicedesk/ongoingticket');
      localStorage.setItem('routingValue', value);
    }else if(value==5){
      this.router.navigateByUrl('/ma_sd/allticket');
    }else if(value==6){
      this.router.navigateByUrl('manager/stand_by_request');
    }else{
      this.router.navigateByUrl('servicedesk/completedticket');
    }
  }
  // // manager/manager_contract
  // approvalPage(approvalPageValue) {
  //   (approvalPageValue==1)?this.router.navigateByUrl('manager/manager_contract'):(approvalPageValue==2)?this.router.navigateByUrl('manager/stand_by_request'):(approvalPageValue==3)?this.router.navigateByUrl('servicedesk/renewal_approval'):(approvalPageValue==4)?this.router.navigateByUrl('manager/reimbursement'):(approvalPageValue==5)?this.router.navigateByUrl('manager/spare_request'):this.router.navigateByUrl('servicedesk/ongoingticket');                               //# to redirect to unassigned page
  // }
  // manager/manager_contract
  approvalPage(approvalPageValue) {
    (approvalPageValue==1)?this.router.navigateByUrl('manager/manager_contract'):(approvalPageValue==2)?this.router.navigateByUrl('manager/stand_by_request'):(approvalPageValue==3)?this.router.navigateByUrl('servicedesk/renewal_approval'):(approvalPageValue==4)?this.router.navigateByUrl('manager/reimbursement'):(approvalPageValue==5)?this.router.navigateByUrl('manager/spare_request'):this.router.navigateByUrl('servicedesk/ongoingticket');                               //# to redirect to unassigned page
  }
  //multiselect dropdown for product {product_id: 1, product_name: 'X-Ray & USG'}
  onItemSelectProduct(items: any) {
    this.product_id_value.push(items.product_id);
    this.productIdvalue = this.product_id_value;
  }
  onSelectAllProduct(items: any) {
    this.productIdvalue =[]
    this.product_id_value =[]
    var isPresent = this.product_id_value.some(function (el) { return el === items.product_id });
    if (isPresent) {
    } else {
      items.forEach(value => {
        this.product_id_value.push(value.product_id); 
      })
    }
    this.productIdvalue = this.product_id_value;
  }
  onItemDeSelectProduct(items: any) {
    const index: number = this.product_id_value.indexOf(items.product_id);
    if (index !== -1) {
      this.product_id_value.splice(index, 1);
    }
    this.productIdvalue = this.product_id_value;
  }
  onItemDeSelectAllProduct(items: any) {
    this.product_id_value =[]
    this.productIdvalue = [];
  }
  //multiselect dropdown for region
  onItemSelectregion(items: any) {
    this.regionId.push(items.region_id);
    this.region_id = this.regionId
  }
  onSelectAllregion(items: any) {
    this.region_id =[]
    this.regionId = []
    var isPresent = this.regionId.some(function (el) { return el === items.region_id });
    if (isPresent) {
    } else {
      items.forEach(value => {
        this.regionId.push(value.region_id); 
      })
    }
    this.region_id = this.regionId

  }
  onItemDeSelectregion(items: any) {
    const index: number = this.region_id.indexOf(items.region_id);
    if (index !== -1) {
      this.region_id.splice(index, 1);
    }
    this.region_id = this.regionId
  }
  onItemDeSelectAllregion(items: any) {
    this.region_id = [];
    this.regionId = []

  }
  // getpass() {
  //   this.employee_code = localStorage.getItem('pro_employee_code');
  //   var employee_code = this.employee_code; // country: number                                    
  //   var url = 'get_userdetails/?';             // api url for getting the details with using post params
  //   var id = "employee_code";
  //   this.ajax.getdataparam(url, id, employee_code).subscribe((result) => {
  //     if (result.response.response_code == "200") {
  //       this.users = result.response.data[0];
  //       this.products = this.users.product;
  //       this.region = this.users.region;
  //       this.region.forEach(value => {
  //         this.region_id.push(value.region_id); 
  //       })
  //       this.chRef.detectChanges();
  //     }
  //   })
  // }
  // // get countvalue
  // get_total_count() {
  //   this.from = moment(this.from).format('YYYY-MM-DD');
	// 	this.to = moment(this.to).format('YYYY-MM-DD');
  //   this.loadingSubmit= true;
  //   var url = 'ticket_tracker/';             // api url for getting the details with using post params
  //   var emp_code = localStorage.getItem('pro_employee_code'); // get employee code 
  //   var data = { "employee_code": emp_code, "product":this.productIdvalue , "region": this.region_id, 'date':this.ProductLocation.value.date,"from_date":(this.ProductLocation.value.date=='')?this.from:'',"to_date":(this.ProductLocation.value.date==''&&this.to!='Invalid date')?this.to:''}
  //   this.ajax.postdata(url, data).subscribe((result) => {//Initiate API Call
  //     if (result.response.response_code == "200") {//if response code 200 i.e Success
  //       this.ticket_count_details = result.response.data[0];//Get respose data
  //       this.loadingSubmit = false;
  //       this.chRef.detectChanges();//Detect Changes
  //     }
  //   }, (err) => {
  //     console.log(err);                                        //prints if it encounters an error
  //   });
  //   console.log(this.ticket_count_details, "00")
  // }
  // datepicker functionality
  // single select region functionality
  onItemSelectState(items: any) {
    this.state_id.push(items.id);
    this.stateId = this.state_id;
  }
  // allselect region functionality
  onSelectAllState(items: any) {
    this.state_id = [];
    this.state_id =[];
    var isPresent = this.state_id.some(function (el) { return el === items.id });
    if (isPresent) {
    } else {
      items.forEach(value => {
        this.state_id.push(value.id);
      })
    }
    this.stateId = this.state_id;
  }
  // single deselect region functionality
  onItemDeSelectState(items: any) {
    const index: number = this.state_id.indexOf(items.id);
    if (index !== -1) {
      this.state_id.splice(index, 1);
    }
    this.stateId = this.state_id;
  }
  // all deselect deselect functionality
  onItemDeSelectAllState() {
    this.stateId = [];
    this.state_id =[];
  }
  changeDataPicker1(data){
    if(this.datePeriod1=="Duration"){
      this.from = this.defaultFrom;
      this.to = this.defaultTo;
      this.datapickerflag1=false;
    }else{
      this.datapickerflag1=true;
      this.getDashboradStatus(this.datePeriod1,data);
    }
  }
  changeDataPicker(data){
    if(this.datePeriod=="Duration"){
      this.from = this.defaultFrom;
      this.to = this.defaultTo;
      this.datapickerflag=false;
    }else{
      this.datapickerflag=true;
      this.getDashboradStatus(this.datePeriod,data);
    }
  }
  getDashboradStatus(duration,value){ // dashboard_status
    console.log(value,"value738")
    if(value==1){
      this.datePeriod1=duration;
      this.datePeriod=duration;
      this.datapickerflag=true;
      this.datapickerflag1=true;
    }
    this.from = moment(this.from).format('YYYY-MM-DD');
		this.to = moment(this.to).format('YYYY-MM-DD');
    this.loadingSubmit= true;
    var url = 'facility_dashboard/';             // api url for getting the details with using post params
    var emp_code = localStorage.getItem('pro_employee_code'); // get employee code 
    // {"duration":"YTD","from_date":"","to_date":"","facility_code":["CU0241","CU0242","CU0003"reg_cust_code
    var data = {
        "region_id": [], 
        'duration':duration,
        "from_date":(duration=='Duration')?this.from:'',
        "to_date":(duration=='Duration'&&this.to!='Invalid date')?this.to:'',
        // "state":this.stateId,
        // "to_date":'2024-03-01',
        // "from_date":'2024-07-01',
        'product_id':this.productIdvalue,
        "customer_code":[localStorage.getItem('reg_cust_code')]
      }
    this.ajax.postdata(url, data).subscribe((result) => {//Initiate API Call
      if (result.response.response_code == "200") {//if response code 200 i.e Success
          localStorage.setItem('user_mobile', result.response.customer_list[0].contact_number);
        if(value==1){
          console.log("value764",value)
          this.assetListData = result.response.asset_list[0] //asset data list
          this.complaintData = result.response.complaint_list[0] //completed data list
          this.pmsData= result.response.pms_list[0] // pms data list
          console.log(this.pmsData,'this.pmsData');
          console.log(this.complaintData,'complaintData')
          console.log(this.assetListData,'assetListData')
          // this.contractData = result.response.contracts_list[0] // contract data list
          // this.mappingData = result.response.mapping_list[0] //mapping data list
          // this.mappingDataChat = [
          //   { 'x': 'Mapping', y: this.mappingData['mapping_percentage'] }, { 'x': 'Spare', y: this.mappingData['sparerequest_percentage'] },
          //   { 'x': 'StandBY', y: this.mappingData['standby_percentage'] },
          // ];//bind mapping data to pie chart 
          this.pmsDataChat = [
            { 'x': 'Completed', y: this.pmsData.completed_percentage }, { 'x': 'Pending', y: this.pmsData.pending_percentage }
          ];//bind pms data to pie chart
          this.complaintDataChat = [
            { 'x': 'Completed', y: this.complaintData.completed_percentage }, { 'x': 'Pending', y: this.complaintData.pending_percentage  }
          ];//bind complaint to pie chart 
          this.assetListDataChat = [
            { 'x': 'Functional', y: this.assetListData.functional_percentage }, { 'x': 'Non Functional', y: this.assetListData.non_functional_percentage }
          ];//bind assetList data to pie chart
          // this.contractDataChat =[
          //   { 'x': 'Completed', y: this.contractData.completed_percentage }, { 'x': 'Pending', y: this.contractData.pending_percentage  }
          // ]; //bind contract data to pie chart
          this.chRef.detectChanges();//Detect Changes
        }else if(value==3){
          this.pmsData= result.response.pms_list[0] // pms data list
          this.pmsDataChat = [
            { 'x': 'Completed', y: this.pmsData.completed_percentage }, { 'x': 'Pending', y: this.pmsData.pending_percentage }
          ];//bind pms data to pie chart
        }else if(value==2){
          this.complaintData = result.response.complaint_list[0] //completed data list
          this.complaintDataChat = [
            { 'x': 'Completed', y: this.complaintData.completed_percentage }, { 'x': 'Pending', y: this.complaintData.pending_percentage  }
          ];//bind complaint to pie chart
        }
        this.chRef.detectChanges();//Detect Changes
        this.loadingSubmit = false;
        // this.chRef.detectChanges();//Detect Changes
      }
    }, (err) => {
      console.log(err);                                        //prints if it encounters an error
    });
  }
  // page redireact
  pageRedirect(pageName,pageCount,pageSection){
    localStorage.setItem('countPage',pageName);
    localStorage.setItem('reportProduct',this.productIdvalue);
    localStorage.setItem('reportState',this.stateId);
    if(pageName=="Asset"){
      console.log("asset")
      localStorage.setItem('pageFilter',pageSection);
      this.router.navigateByUrl('customer/assetStatusReport');
    }else if(pageName=="pms"){
      localStorage.setItem('pageFilter',pageSection);
      localStorage.setItem('durartion',(this.datePeriod=='Duration')?'':this.datePeriod);
      localStorage.setItem('toDate',(this.datePeriod!='Duration')?'':this.to);
      localStorage.setItem('fromDate',(this.datePeriod!='Duration')?'':this.from);
      this.router.navigateByUrl('customer/pmsSummary');
    }else{
      console.log(pageSection,'pageSection')
      localStorage.setItem('pageFilter',pageSection);
      localStorage.setItem('durartion',(this.datePeriod1=='Duration')?'':this.datePeriod1);
      localStorage.setItem('toDate',(this.datePeriod1!='Duration')?'':this.to);
      localStorage.setItem('fromDate',(this.datePeriod1!='Duration')?'':this.from);
      this.router.navigateByUrl('customer/jobReport');
    }
    console.log(this.to,"this.tothis.to",localStorage.getItem('toDate'))
  }
  // get Product details
  getProductDetails() {
    this.cusCode = localStorage.getItem('reg_cust_code');
    var employee_code = this.employee_code; // country: number                                    
    var url = 'customer_product_details/?';             // api url for getting the details with using post params
    var id = "customer_code";
    this.ajax.getdataparam(url, id, this.cusCode).subscribe((result) => {
      if (result.response.response_code == "200") {
        this.products = result.response.data;
        console.log(this.products,"products")
        this.chRef.detectChanges();
      }
    })
  }
}
